let vars = {};

vars.document = document;
vars.window = window;
vars.html = document.documentElement;
vars.body = document.body;
vars.header = document.querySelector('.header');
vars.burger = document.querySelector('.burger');
vars.menu = document.querySelector('.menu');
vars.home = document.querySelector('.home');
vars.social = document.querySelector('.social');
vars.links = document.querySelectorAll('[href^="#"]');
vars.duration = 0.5;
vars.isMobile = () => innerWidth <= 1024;
vars.winWidth = window.innerWidth;
vars.path = '/iskusstvenniy-intellekt/';
vars.search = document.location.search ? document.location.search : '';

vars.update = () => {
	vars.header = document.querySelector('.header');
	vars.burger = document.querySelector('.burger');
	vars.menu = document.querySelector('.menu');
	vars.home = document.querySelector('.home');
	vars.social = document.querySelector('.social');
	vars.links = document.querySelectorAll('[href^="#"]');
};

export default vars;
